var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.71875 14.2188L11.4688 9.75C11.625 9.59375 11.8125 9.5 12 9.5C12.1562 9.5 12.3438 9.59375 12.5 9.71875L17.25 14.1875C17.5625 14.4688 17.5625 14.9375 17.2812 15.25C17 15.5625 16.5312 15.5625 16.2188 15.2812L11.9688 11.2812L7.75 15.2812C7.4375 15.5625 6.96875 15.5625 6.6875 15.25C6.40625 14.9688 6.40625 14.5 6.71875 14.2188Z",
    fill: "#0D3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleUp);
export default __webpack_public_path__ + "static/media/AngleUp.a2a32c856f7d2dc261265972fbcfae3c.svg";
export { ForwardRef as ReactComponent };